export default __webpack_public_path__ + "static/media/toggle-off.11120952.svg";